import { Injectable, Type } from '@angular/core';
import { Confirmation, ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Injectable({
  providedIn: 'root',
  useValue:[DialogService]
})
export class ToastService {

  life: number = 4000;
  constructor(private messageService : MessageService,
    private cfService : ConfirmationService,
    public dialogService:DialogService
    ) { }

  showInfo(detail : string){
    this.messageService.add({
      severity: 'info',
      summary: "Información",
      detail: detail,
      life: this.life
    });
  }
  
  showInfoNotification(detail : string,  life? : number){
    this.messageService.add({
      severity: 'info',
      summary: "Nueva notificación",
      detail: detail,
      life: life ?? this.life,
      icon: "fa-brands fa-whatsapp"
    });
  }

  showSucces(detail : string){
    this.messageService.add({
      severity: 'success',
      summary: "¡Correcto!",
      detail: detail,
      life: this.life
    });
  }

  showWarn(detail : string, life?: number){
    this.messageService.add({
      severity: 'warn',
      summary: "¡Ups!",
      detail: detail,
      life: life ?? this.life
    });
  }

  showError(detail : string, life?: number){
    this.messageService.add({
      severity: 'error',
      summary: "¡Error!",
      detail: detail,
      life: life ?? this.life
    });
  }
  
  clear(){
    this.messageService.clear();
  }

  showConfirmation(confirmation : Confirmation){
    this.cfService.confirm(
      {
        ...confirmation,
        rejectButtonStyleClass: "p-button-danger p-button-outlined",
        acceptButtonStyleClass: "p-button-success p-button-outlined",
        defaultFocus: 'none'
      });
  }
  open(componentType: Type<any>, config: DynamicDialogConfig<any>) : DynamicDialogRef{
    return this.dialogService.open(componentType,
      {
        ...config
      }
      );
  }

}
